import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './QtrDirectPremiumRow.module.css';
import headerStyles from './QtrDirectPremiumRowHeader.module.css';

interface QtrDirectPremiumRowHeaderProps {
  readonly helmet: {
    label?: string;
    hasBenchmarkAnalysis?: boolean;
  };
  /** Whether to show the Premium % Change column label */
  readonly showPremiumPercentChange?: boolean;
  /** Whether to show the Premium $ Change column label */
  readonly showDollarNumberChange?: boolean;
}

export default function QtrDirectPremiumRowHeader({
  helmet,
  showPremiumPercentChange = false,
  showDollarNumberChange = false
}: QtrDirectPremiumRowHeaderProps) {
  const { showBenchmark } = useContext(AppContext);
  const collapseClass = showBenchmark ? '' : `${styles.collapse} ${headerStyles.collapse}`;

  return (
    <div className={headerStyles.headerWrapper} data-testid="qtr-direct-premium-row-header">
      {/* Top Row: Group headers ("Current Quarter" / "Prior Year Quarter") */}
      <div className={`${styles.container} ${collapseClass} ${headerStyles.topRow}`}>
        <h5 className={`${headerStyles.groupHeader} ${headerStyles.currentQuarter}`}>
          Current Quarter
        </h5>
        <h5 className={`${headerStyles.groupHeader} ${headerStyles.priorYearQuarter}`}>
          Prior Year Quarter
        </h5>
      </div>

      {/* Bottom Row: Column labels */}
      <div className={`${styles.container} ${collapseClass} ${headerStyles.bottomRow}`}>
        <h5 className={headerStyles.textLeft}>{helmet.label}</h5>
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5 className={headerStyles.columnAlignCenter} aria-hidden={!helmet.hasBenchmarkAnalysis}>
          {showBenchmark && helmet.hasBenchmarkAnalysis ? 'Benchmark' : ''}
        </h5>
        <h5 className="column_align_right" aria-hidden={!showPremiumPercentChange}>
          {showPremiumPercentChange ? 'Premium % Change' : ''}
        </h5>
        <h5 className="column_align_right" aria-hidden={!showDollarNumberChange}>
          {showDollarNumberChange ? '$/# Change' : ''}
        </h5>
        <h5 className="column_align_right">Direct Prem</h5>
        <h5 className="column_align_right">% of Total</h5>
        <h5 className="column_align_right">Direct Prem</h5>
        <h5 className="column_align_right">% of Total</h5>
      </div>
    </div>
  );
}
